import * as React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, Typography, Box, Backdrop } from "@material-ui/core";

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" color='white' size="60px" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
          style={{ fontSize:"18px", fontWeight: "bold" }}
        >
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

CircularProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number.isRequired,
};

export default (props) => {
  return (
    <>
      <Backdrop
        style={{ zIndex: 1500, color: "white" }}
        open={props.state.progressPercentZipBoolean}
      >
        <Typography
          style={{ fontSize:"28px", fontWeight: "bold", marginRight: "20px" }}
        >
          Baixando as etiquetas...
        </Typography>
        
        {props.state.progressPercentZip === 0
        ? (
          <CircularProgress size="60px" color='white' />
        )
        : (
          <CircularProgressWithLabel value={props.state.progressPercentZip}/>
        )
        }
      </Backdrop>
    </>
  );
}
